import { LOCATION_STATE, NZ_STATE } from 'models/Listing';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const LOCATION_URL_MAPPING = {
  ...LOCATION_STATE,
  [LOCATION_STATE.INTERNATIONAL]: LOCATION_STATE.INTERNATIONAL,
  [LOCATION_STATE.NNZ]: NZ_STATE,
  [LOCATION_STATE.SNZ]: NZ_STATE,
};

export default function useLocationMapper() {
  const { t } = useTranslation();

  const locationLabelMapper = useMemo(
    () => ({
      [LOCATION_STATE.NSW]: t('nsw'),
      [LOCATION_STATE.VIC]: t('vic'),
      [LOCATION_STATE.QLD]: t('qld'),
      [LOCATION_STATE.WA]: t('wa'),
      [LOCATION_STATE.SA]: t('sa'),
      [LOCATION_STATE.TAS]: t('tas'),
      [LOCATION_STATE.ACT]: t('act'),
      [LOCATION_STATE.NT]: t('nt'),
      [LOCATION_STATE.NNZ]: t('nnz'),
      [LOCATION_STATE.SNZ]: t('snz'),
      [LOCATION_STATE.INTERNATIONAL]: t('International'),
    }),
    [t],
  );

  return {
    locationLabelMapper,
  };
}
